function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.003,
    viewBox: "0 0 24 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-fire",
    d: "M10.568 25.931c-1.6-3.329-.748-5.236.482-7.033a11.2 11.2 0 0 0 1.693-3.916 4.6 4.6 0 0 1 .635 3.528 8.9 8.9 0 0 0 1.94-6.668 11.514 11.514 0 0 1 3.6 14.089c12.947-7.331 3.22-18.288 1.526-19.522.564 1.235.672 3.325-.469 4.339-1.93-7.32-6.7-8.82-6.7-8.82.564 3.775-2.046 7.9-4.564 10.987a8.158 8.158 0 0 0-.974-3.984c-.178 2.734-2.267 4.963-2.833 7.7-.769 3.713.572 6.43 5.664 9.3z",
    transform: "translate(-3.121 -1.928)",
    style: {
      fill: "#204bf8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.3fe84bf2b9639531743c75096f7b7d17.svg";
export { ForwardRef as ReactComponent };